import { useEffect } from "react"
import { useState } from "react"
import { axiosDisposisi, axiosTte,axiosAuth,errorHandling } from "../../helpers"
import { useDispatch, useSelector } from "react-redux"
import { changeTokenApp, loginData, logout } from "../../stores/auth"
import { useNavigate } from "react-router-dom"

import swal from "sweetalert"
const useHome = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const dataLogin = useSelector(loginData)
    const baseUrl = process.env.REACT_APP_BASEURL
    const [defaultApp, setDefaultApp] = useState([
        {
            "title": "Agenda",
            "description": "Aplikasi Agenda Pimpinan Kementerian Agama RI",
            "image": `${baseUrl}/assets/img/disposition.png`,
            "url": "/agenda"
        },
        // {
        //     "title": "Disposisi",
        //     "description": "Aplikasi Disposisi Kementerian Agama RI",
        //     "image": `${baseUrl}/assets/img/disposition.png`,
        //     "url": "/disposisi"
        // },
        // {
        //     "title": "TTE",
        //     "description": "Aplikasi Tanda Tangan Elektronik Kementerian Agama RI",
        //     "image": `${baseUrl}/assets/img/tte.png`,
        //     "url": "/tte"
        // },
    ])
    const [apps, setApps] = useState([])
    const [keyword, setKeyword] = useState("")


    const getProfileData = async () => {
        try {
            // setIsLoading(true)
            const response = await axiosAuth.get(`/v1/profile`, {
                headers: {
                    'Authorization': `Bearer ${dataLogin.token_account}`,
                }
            });

            if (response.data.status_code === 200) {
                // setData(response.data.data)
                if(response.data.data.kode_satker_utama==''){
                    swal("Satker Belum Diisi","Silahkan lakukan pemilihan satker dahulu di profil",'error')
                    navigate('/profile')
                }
                // const nip = decodeToken(dataLogin.token_account)['nip'];
                // let mSatkerFind = allSatker.find(satker => satker.kode_satuan_kerja === data.kode_satker_utama)
                // if (mSatkerFind && mSatkerFind?.kode_satuan_kerja) {

                    // let selectedOptionDari =
                    //     { value: response.data.data.kode_satker_utama, label: response.data.data.satuan_kerja }
                    // setFormDataSatker({ ...formDataSatker, nip: nip, kode_satker_utama: selectedOptionDari })
                    // console.log(selectedOptionDari)
                // }

                // setFormDataSatker({ ...formDataSatker, nip: nip, kode_satker_utama: response.data.data.kode_satker_utama })
                // console.log(response.data.data.kode_satker_utama)
                // setSelectedValue(response.data.data.kode_satker_utama)
            } else {
                // swal('Terjadi Kesalahan', "Silakan coba beberapa saat lagi atau hubungi developer", 'error')
            }
        } catch (err) {
            swal('Error', errorHandling(err), 'error')
            if (err.status === 401) {
                dispatch(logout())
            }
        } finally {
            // setIsLoading(false)
        }
    }
    useEffect(() => {
        getProfileData()
        getExchangeTokenDisposisi()
        getExchangeTokenTte()
        setApps(defaultApp)
        const delayDebouncer = setTimeout(() => {
            handleSearch()
        }, 500)
        return () => clearTimeout(delayDebouncer)
    }, [keyword])

    const getExchangeTokenTte = async () => {
        try {
            const responseTokenExchange = await axiosTte.post("/v1/token/exchange", {}, {
                headers: {
                    'Authorization': `Bearer ${dataLogin.token_account}`,
                }
            })
            if (dataLogin.token_tte !== responseTokenExchange.data.data.token) {
                dispatch(changeTokenApp({
                    app: "tte",
                    token: responseTokenExchange.data.data.token
                }))
                window.location.reload()
            }
        } catch (err) {
            console.log(err);
        }
    }

    const getExchangeTokenDisposisi = async () => {
        try {
            const responseTokenExchange = await axiosDisposisi.post("/v1/token/exchange", {}, {
                headers: {
                    'Authorization': `Bearer ${dataLogin.token_account}`,
                }
            })
            if (dataLogin.token_disposisi !== responseTokenExchange.data.data.token) {
                dispatch(changeTokenApp({
                    app: "disposisi",
                    token: responseTokenExchange.data.data.token
                }))
                window.location.reload()
            }
        } catch (err) {
            console.log(err);
        }
    }

    const handleSearch = () => {
        const newApps = [...defaultApp]
        const filtered = newApps.filter(
            (app) => app.title.toLowerCase().includes(keyword)
        );
        setApps(filtered)
    }


    return {
        apps,
        setKeyword,
    }
}
export default useHome